import { FileCheck, Shield, Briefcase, Globe } from "lucide-react";

const credibilityItems = [
  {
    icon: FileCheck,
    label: "Property Due Diligence"
  },
  {
    icon: Shield,
    label: "Title Verification"
  },
  {
    icon: Briefcase,
    label: "Acquisition Advisory"
  },
  {
    icon: Globe,
    label: "Diaspora Investment Advisory"
  }
];

export const TrustedInvestorsSection = () => {
  return (
    <section 
      className="py-16 md:py-24 lg:py-32 bg-[#0A0A0B] relative overflow-hidden"
      data-testid="trusted-investors-section"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      
      {/* Decorative corner accents */}
      <div className="absolute top-12 left-12 w-20 h-20 border-l border-t border-[#D4AF37]/15 hidden lg:block" />
      <div className="absolute bottom-12 right-12 w-20 h-20 border-r border-b border-[#D4AF37]/15 hidden lg:block" />
      
      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
            Global Reach
          </span>
          <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-white mt-4 md:mt-6 leading-tight">
            Trusted by Investors
            <span className="block text-[#D4AF37] italic mt-2">Across the Diaspora</span>
          </h2>
          <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mt-6 md:mt-8" />
        </div>

        {/* Content */}
        <div className="space-y-6 md:space-y-8 text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <p className="text-white/70 text-sm md:text-base lg:text-lg leading-[1.9] md:leading-[2]">
            4 ACES Attorneys provides specialised legal counsel for investors seeking secure property 
            transactions in Nigeria. Our firm regularly advises clients based in Nigeria and across 
            the global diaspora, including the United Kingdom, the United States, Canada, and the 
            United Arab Emirates.
          </p>
          
          <p className="text-white/70 text-sm md:text-base lg:text-lg leading-[1.9] md:leading-[2]">
            Through meticulous due diligence, title verification, and structured acquisition advisory, 
            we help clients navigate Nigeria's property market with clarity, security, and confidence.
          </p>
        </div>

        {/* Credibility Strip */}
        <div className="border-t border-[#D4AF37]/20 pt-10 md:pt-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {credibilityItems.map((item, index) => (
              <div 
                key={index} 
                className="flex flex-col items-center text-center group"
                data-testid={`trusted-item-${index}`}
              >
                <div className="w-12 h-12 md:w-14 md:h-14 border border-[#D4AF37]/30 flex items-center justify-center mb-3 md:mb-4 group-hover:border-[#D4AF37] group-hover:bg-[#D4AF37]/10 transition-all duration-300">
                  <item.icon className="w-5 h-5 md:w-6 md:h-6 text-[#D4AF37]" />
                </div>
                <span className="text-white/70 text-xs md:text-sm font-medium leading-tight">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
